<script module lang="ts">
	let trackedAssignments: string[] = [];
</script>

<script lang="ts">
	import type { EppoData } from '../types';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';
	import { trackEvent } from '$lib/segment/client';
	import { storyblok } from '$lib/state/storyblok.svelte';

	interface Props {
		content: ISbStoryData<EppoData>['content'];
	}

	let { content }: Props = $props();

	let displayInEditor = $derived(content.show_in_editor && storyblok.editMode);
	let isAssigned = $derived(content.eppo.assignment.variation === content.eppo.variant.key);

	$effect(() => {
		if (trackedAssignments.includes(content.eppo.feature_flag.key)) return;

		trackEvent(
			`Eppo Assignment | ${content.eppo.feature_flag.key} | ${content.eppo.assignment.variation}`
		);
		trackedAssignments.push(content.eppo.feature_flag.key);
	});
</script>

<div use:editable={content} class="contents" data-eppo-forced-in-editor={displayInEditor || null}>
	{#if isAssigned || displayInEditor}
		{#each content.content as blok}
			<Blok content={blok} />
		{/each}
	{/if}
</div>
